import { styled } from '@mui/material/styles'
import { Text } from '@atbay/component-lib'
import { CSSProperties } from 'react'

export const StyledText = styled(Text)<{
    color: string
    whiteSpaceRule?: CSSProperties['whiteSpace']
}>`
    color: ${({ color }) => (color ? color : 'inherit')};
    white-space: ${({ whiteSpaceRule }) => whiteSpaceRule};
`
